import Repository from '../repository';

const resource = '/blog';

export default {
  page() {
    return {
      getBySlug(slug, params) {
        return Repository.get(`${resource}/page/${slug}`, { params });
      },
    };
  },
  post() {
    return {
      get(params) {
        return Repository.get(`${resource}/post`, { params });
      },
      getBySlug(slug, params) {
        return Repository.get(`${resource}/post/${slug}`, { params });
      },
    };
  },
  category() {
    return {
      get(params) {
        return Repository.get(`${resource}/category`, { params });
      },
      getBySlug(slug, params) {
        return Repository.get(`${resource}/category/${slug}`, { params });
      },
    };
  },
};
